angular.module("app").controller("SkinsListPageController", [
    '$scope',
    'preloadedSkinsList',
    'pageStatuses',
    '$timeout',
    'pagination',
    'skinService',
    'errorHandler',
    'logger',
    'settingsService',
    '$filter',
    '$uibModal',
    'configsService',
    'userStorage',
    'mobileConfigsService',
    function ($scope, preloadedSkinsList, pageStatuses, $timeout, pagination, skinService, errorHandler, logger, settingsService, $filter, $modal, configsService, userStorage, mobileConfigsService) {

        var pendingListRequest;
        $scope.pageStatuses = pageStatuses;

        $scope.ignoreColumns = {
            'languages': true,
            'url': true,
            'mobile_url': true,
            'new_mobile_url': true,
            'new_web_url': true,

            'defaultLang': true,
            'release_folder_name': true,
            'new_mobile_release_folder_name': true,
            'new_web_release_folder_name': true,
            'mobile_release_folder_name': true,
            'server_name': true,
            'mobile_server_name': true,
            'new_mobile_server_name': true,
            'new_web_server_name': true,

            'created_at': true,
            "for_config_test": true,
            "server": true,
            "authLogin": true,
            "authPass": true,
            "license_id": true,
            'allow_mobile_configs': true,
            'mobile_build_status': true,
            'products': true,
            'use_game_license_image': true,
            'casino_image_type': true,
        };
        if (userStorage.getUserData().permissions.indexOf('manageSkins') !== -1 ) {
            $scope.tools = {
                edit: {
                    action: function (item) {
                        $scope.editSkin(item);
                    }
                },
                generateConfigs: {
                    title: function () {
                        return $filter('translate')("skins.list.generateConfigs");
                    },
                    action: function (row) {
                        generateConfigs(row);
                    },
                    disabled: function (row) {
                        return row.for_config_test === '1';
                    },
                    class: function () {
                        return "fa-dot-circle-o";
                    }
                },
                generateMobileConfigs: {
                    title: function () {
                        return $filter('translate')("skins.list.generateMobileConfigs");
                    },
                    action: function (row) {
                        generateMobileConfigs(row);
                    },
                    disabled: function (row) {
                        return row.allow_mobile_configs === '1';
                    },
                    class: function () {
                        return "fa-dot-circle-o";
                    }
                }
            };
        }
        /**
         * Generate skin configs
         */
        function generateConfigs(row){
            configsService.generateSkinConfigs({skin_id: row.id}).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("global.skinConfigsSuccessfullyGenerated");
                        row.for_config_test = "1";
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        /**
         * Generate mobile configs
         */
        function generateMobileConfigs(row){
            mobileConfigsService.generateSkinConfigs({skin_id: row.id}).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("global.mobileConfigsSuccessfullyGenerated");
                        row.allow_mobile_configs = "1";
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }



        $scope.skins = angular.copy(preloadedSkinsList.skins);

        $scope.filterOptions = {
            global: "all",
            spring_builder: "all"
        };

        $scope.filterOptions = angular.extend({}, $scope.filterOptions, settingsService.getFilters());
        $scope.pagination = pagination.init(function () {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);
            pendingListRequest = $timeout(function () {
                $scope.updateList({
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                })
            }, 300);
        }, preloadedSkinsList.total_count, 25);

        $scope.updateList = function (requestOptions) {
            var requestData = {};

            !!requestOptions && angular.extend(requestData, requestOptions);

            angular.extend(requestData, getFiltersData());

            settingsService.setFilters(requestOptions);
            skinService.getAllSkinsList(requestData).then(
                function (response) {
                    if (response && response.status === "ok") {
                        $scope.skins = angular.copy(response.skins);
                        $scope.pagination.totalItems = response.total_count;
                    } else {
                        errorHandler((response) ? response.message : "");
                    }
                },
                function (response) {
                    errorHandler((response) ? response.message : "");
                }
            )
        };

        /*
            *@ngdoc method
            *@name addSkins
            *@description When you want to open Media popup in Media View
        */
        $scope.addSkins = function () {
            $modal.open({
                templateUrl: "views/skins/add.html",
                controller: "AddSkinPageController",
                resolve: {
                    preloadedLanguages: function (generalService, errorHandler) {
                        return generalService.getAllLanguages().then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response)
                                }
                                errorHandler(response.message);
                                return {}
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    preloadedSkins: function (skinService, errorHandler, pageStatuses, userStorage, $filter) {
                        if (userStorage.getUserData().permissions.indexOf('manageSkins') === -1) {
                            return []
                        }
                        return skinService.getAllSkinsList({status: pageStatuses[0]}).then(
                            function (response) {
                                var orderBy = $filter("orderBy"),
                                    result = [];
                                if (response && response.status === "ok") {
                                    result = angular.copy(orderBy(response.skins, "id"));
                                    result.unshift({name: "Select Skin", id: null});
                                    return result;
                                } else {
                                    errorHandler((response) ? response.message : "");
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        )
                    },
                    preloadedLicense: function (licenseService, errorHandler) {
                       return licenseService.get().then(function (response) {
                                if (response && response.status === "ok") {
                                    return response.data;
                                } else {
                                    errorHandler((response) ? response.message : "");
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        );

                    },
                    preloadedProducts: function (skinService, errorHandler) {
                        return skinService.getAllProducts().then(function (response) {
                                if (response && response.status === "ok") {
                                    return response.data;
                                } else {
                                    errorHandler((response) ? response.message : "");
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        );

                    }
                }
            }).result.then(function () {
                $scope.updateList({
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                })
            });
        };

        $scope.editSkin = function (skin) {
            $modal.open({
                templateUrl: "views/skins/edit.html",
                controller: "EditSkinPageController",
                resolve: {
                    preloadedSkinData: function (skinService, errorHandler) {
                        return skinService.getSkinById({id: skin.id}).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response)
                                }
                                return null
                            },
                            function (response) {
                                errorHandler(response.message);
                                return null
                            }
                        )
                    },
                    preloadedLanguages: function (generalService, errorHandler) {
                        return generalService.getAllLanguages().then(
                            function (response) {
                                if (response.status === "ok") {
                                    return angular.copy(response)
                                }
                                errorHandler(response.message);
                                return {}
                            },
                            function (response) {
                                errorHandler(response.message);
                                return {}
                            }
                        )
                    },
                    preloadedLicense: function (licenseService, errorHandler) {
                        return licenseService.get().then(function (response) {
                                if (response && response.status === "ok") {
                                    return response.data;
                                } else {
                                    errorHandler((response) ? response.message : "");
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        );

                    },
                    preloadedProducts: function (skinService, errorHandler) {
                        return skinService.getAllProducts().then(function (response) {
                                if (response && response.status === "ok") {
                                    return response.data;
                                } else {
                                    errorHandler((response) ? response.message : "");
                                    return {}
                                }
                            },
                            function (response) {
                                errorHandler((response) ? response.message : "");
                                return {}
                            }
                        );

                    }
                }
            }).result.then(function () {
                $scope.updateList({
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                })
            })
        };

        $scope.deleteSkin = function (skin) {
            var requestData = {
                skin: {
                    id: skin.id
                }
            };

            skinService.deleteSkin(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.pagination.changePage();
                        logger.logSuccess("Skin has been successfully archived");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )        };

        $scope.publishSkin = function (skin) {
            var requestData = {
                skin: {
                    id: skin.id,
                    status: "published"
                }
            };

            skinService.editSkin(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.pagination.changePage();
                        logger.logSuccess("Skin has been successfully published");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };


        function getFiltersData () {

            var filters = {},
                global = (($scope.filterOptions.global === 'active') || (($scope.filterOptions.global === 'all') ? undefined : false)),
                search = $scope.filterOptions.search,
                spring_builder = (($scope.filterOptions.spring_builder === 'active') || (($scope.filterOptions.spring_builder === 'all') ? undefined : false));

            global != undefined && (filters.global = global);
            spring_builder != undefined && (filters.spring_builder = spring_builder);
            !!search && (filters.search = search);

            return filters
        }
        $scope.listFilterObject = {
            action: function () {
                $scope.updateList({
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                });
            }
        };
    }
]);
